import isEqual from "lodash-es/isEqual";

const PREVENTION_TOKEN_EXP_TIME = 10; // Time in seconds, to avoiding token expiration during request-response process
export const AUTH_USER_STORAGE_KEY_NAME = "powerManageRepoAuthUser";
export const AUTH_TOKENS_STORAGE_KEY_NAME = "powerManageRepoAuthTokens";

export const clearAuthInfoFromLocalStorage = () => {
  window.localStorage.removeItem(AUTH_USER_STORAGE_KEY_NAME);
  window.localStorage.removeItem(AUTH_TOKENS_STORAGE_KEY_NAME);
  dispatchEventUserInfoChanged();
};

export const setAuthInfoToStorage = (authInfo) => {
  const { token, refresh_token, payload } = authInfo;
  const { exp, origIat, ...userInfo } = payload;
  window.localStorage.setItem(
    AUTH_TOKENS_STORAGE_KEY_NAME,
    JSON.stringify({
      token,
      refresh_token,
      exp,
      origIat,
    }),
  );
  const userData = { ...userInfo, authenticated: !!token };
  setUserInfoToLocalStorage(userData);
};

export const getTokenFromStorage = () => {
  return getTokensFromStorage().token;
};

export const getRefreshTokenFromStorage = () => {
  return getTokensFromStorage().refresh_token;
};

export const shouldRefreshToken = () => {
  const expTokenTime = getTokensFromStorage().exp;
  if (!expTokenTime) {
    return false;
  }
  const currentTime = Math.floor(Date.now() / 1000);
  return currentTime > expTokenTime - PREVENTION_TOKEN_EXP_TIME;
};

const getUserFromStorage = () => {
  const storageData = window.localStorage.getItem(AUTH_USER_STORAGE_KEY_NAME);
  return storageData ? JSON.parse(storageData) : {};
};

const getTokensFromStorage = () => {
  const storageData = window.localStorage.getItem(AUTH_TOKENS_STORAGE_KEY_NAME);
  return storageData ? JSON.parse(storageData) : {};
};

const dispatchEventUserInfoChanged = (newValue = null) => {
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: AUTH_USER_STORAGE_KEY_NAME,
      newValue,
      oldValue: window.localStorage.getItem(AUTH_USER_STORAGE_KEY_NAME),
      storageArea: window.localStorage,
    }),
  );
};

const setUserInfoToLocalStorage = (userData) => {
  if (isEqual(userData, getUserFromStorage())) {
    return;
  }
  const newData = JSON.stringify(userData);
  window.localStorage.setItem(
    AUTH_USER_STORAGE_KEY_NAME,
    JSON.stringify(userData),
  );
  dispatchEventUserInfoChanged(newData);
};
